// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__gNrq1","navbar":"styles_navbar__Q4E29","navlinks":"styles_navlinks__k+sOQ","buttons":"styles_buttons__GqJgt","complaintbtn":"styles_complaintbtn__GWfCk"};